import StatusList from './StatusList';

export default {
    list: 	StatusList
};
